import gql from "graphql-tag";

export function episodeListQuery(params) {
    return {
        query: gql`
            query($productId: ID!) {
                result: product(id: $productId) {
                    ... on Season {
                        episodes {
                            id
                            title
                            prodNumber: productionNumber
                            domNumber: episodeNumber
                            originalAirRunningOrder
                            originalAirDate
                            f0_num
                            rating
                            shortSynopsis
                            mediumSynopsis
                            fullSynopsis
                        }
                    }
                }
            }
        `,
        variables: params,
    };
}
